// Mock data for FixFlow Mobile Repair Service

export const serviceOptions = [
  {
    id: 1,
    title: "Book a Pickup",
    description: "Schedule a convenient time for our technician to collect your device from your location",
    icon: "calendar",
    image: "https://images.unsplash.com/photo-1731391747600-4d0f478b2184"
  },
  {
    id: 2,
    title: "Track Your Repair",
    description: "Monitor your device repair status in real-time with live updates",
    icon: "map-pin",
    image: "https://images.unsplash.com/photo-1611396000732-f8c9a933424f"
  },
  {
    id: 3,
    title: "Doorstep Delivery",
    description: "Get your repaired device delivered back to your doorstep",
    icon: "package",
    image: "https://images.pexels.com/photos/1476321/pexels-photo-1476321.jpeg"
  }
];

export const repairTypes = [
  { id: 1, name: "Screen Replacement", price: 89 },
  { id: 2, name: "Battery Replacement", price: 69 },
  { id: 3, name: "Camera Repair", price: 79 },
  { id: 4, name: "Charging Port", price: 59 },
  { id: 5, name: "Water Damage", price: 129 }
];

export const phoneModels = [
  { id: 1, brand: "iPhone", models: ["iPhone 15 Pro", "iPhone 15", "iPhone 14 Pro", "iPhone 14", "iPhone 13", "iPhone 12", "iPhone 11"] },
  { id: 2, brand: "Samsung", models: ["Galaxy S24", "Galaxy S23", "Galaxy S22", "Galaxy A54", "Galaxy A34"] },
  { id: 3, brand: "Google", models: ["Pixel 9", "Pixel 8", "Pixel 7"] },
  { id: 4, brand: "OnePlus", models: ["OnePlus 12", "OnePlus 11", "OnePlus 10"] }
];

export const customerPosts = [
  {
    id: 1,
    username: "sarah_tech",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    image: "https://images.unsplash.com/photo-1735875530804-d661ca2001da",
    caption: "Amazing service! Screen replaced in 2 hours, picked up and delivered to my home. Highly recommend!",
    device: "iPhone 15 Pro",
    service: "Screen Replacement",
    likes: 234,
    comments: [
      { id: 1, username: "mike_jones", text: "How much did it cost?", timestamp: "2h ago" },
      { id: 2, username: "sarah_tech", text: "$89, totally worth it!", timestamp: "2h ago" }
    ],
    timestamp: "3 hours ago",
    liked: false
  },
  {
    id: 2,
    username: "john_mobile",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
    image: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg",
    caption: "Battery replacement was quick and easy. Love the doorstep service!",
    device: "Samsung Galaxy S23",
    service: "Battery Replacement",
    likes: 189,
    comments: [
      { id: 3, username: "lisa_m", text: "Did they come to your place?", timestamp: "1h ago" },
      { id: 4, username: "john_mobile", text: "Yes! Picked up in the morning, delivered by evening.", timestamp: "1h ago" }
    ],
    timestamp: "5 hours ago",
    liked: false
  },
  {
    id: 3,
    username: "emma_davis",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
    image: "https://images.pexels.com/photos/5726706/pexels-photo-5726706.jpeg",
    caption: "Professional technicians! They fixed my camera issue perfectly. 5 stars!",
    device: "Google Pixel 9",
    service: "Camera Repair",
    likes: 312,
    comments: [
      { id: 5, username: "alex_r", text: "How long did it take?", timestamp: "30m ago" },
      { id: 6, username: "emma_davis", text: "Same day service! Amazing!", timestamp: "25m ago" }
    ],
    timestamp: "1 day ago",
    liked: true
  },
  {
    id: 4,
    username: "david_wong",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
    image: "https://images.pexels.com/photos/719399/pexels-photo-719399.jpeg",
    caption: "Water damage repair saved my phone! These guys are miracle workers!",
    device: "iPhone 14",
    service: "Water Damage Repair",
    likes: 445,
    comments: [
      { id: 7, username: "nina_p", text: "Wow! I need this service!", timestamp: "3h ago" },
      { id: 8, username: "raj_tech", text: "They're the best in town!", timestamp: "2h ago" }
    ],
    timestamp: "2 days ago",
    liked: false
  },
  {
    id: 5,
    username: "maria_lopez",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb",
    image: "https://images.unsplash.com/photo-1731391777974-18f9adb69490",
    caption: "Shattered screen to brand new! The pickup and delivery made it so convenient.",
    device: "Samsung Galaxy S24",
    service: "Screen Replacement",
    likes: 267,
    comments: [
      { id: 9, username: "tom_k", text: "Looks perfect!", timestamp: "5h ago" }
    ],
    timestamp: "3 days ago",
    liked: false
  },
  {
    id: 6,
    username: "chris_brown",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
    image: "https://images.unsplash.com/photo-1611396000732-f8c9a933424f",
    caption: "Charging port fixed in hours! Super impressed with the service quality.",
    device: "OnePlus 12",
    service: "Charging Port Repair",
    likes: 198,
    comments: [
      { id: 10, username: "kelly_s", text: "I need to try this!", timestamp: "1d ago" }
    ],
    timestamp: "4 days ago",
    liked: false
  }
];

export const guaranteeInfo = {
  warranty: "15-day guarantee on all repairs",
  genuineParts: "We use only certified, high-quality replacement parts",
  certifiedTechs: "All technicians are certified and experienced professionals",
  insurance: "Fully insured pickup and delivery service"
};